export type ResourceType = "adhoc" | "study";
